import React from 'react';

const Card = ({ children, className = '', title, subtitle, hover = false }) => {
  return (
    <div className={`bg-white border border-brand-border rounded-md overflow-hidden transition-all duration-200 ${hover ? 'hover:shadow-card hover:border-transparent' : ''} ${className}`}>
      {(title || subtitle) && (
        <div className="px-4 py-3 border-b border-brand-border">
          {title && <h3 className="text-lg font-bold text-brand-dark">{title}</h3>}
          {subtitle && <p className="text-sm text-brand-muted mt-1">{subtitle}</p>}
        </div>
      )}
      <div className={!title && !subtitle ? 'p-4' : 'p-4'}>{children}</div>
    </div>
  );
};

export default Card;